module.exports = __webpack_public_path__ + "static/media/Протокол от заседание на СД на _Формопласт_АД за свикване на ОСА..14f358db.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2021/Протокол от заседание на СД на _Формопласт_АД за свикване на ОСА..pdf
// module id = 106
// module chunks = 0